import { useIntercom } from 'react-use-intercom';

function UseIntercomHook(Component) {
  return function WrappedComponent() {
    const { boot, update } = useIntercom();
    return <Component boot={boot} update={update} />
  }
}

export default UseIntercomHook;